import { render } from "./SportesTools.vue?vue&type=template&id=01fb2d9b&scoped=true"
import script from "./SportesTools.vue?vue&type=script&lang=js"
export * from "./SportesTools.vue?vue&type=script&lang=js"

import "./SportesTools.vue?vue&type=style&index=0&id=01fb2d9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fb2d9b"]])

export default __exports__